import { render, staticRenderFns } from "./ServiceTrain.vue?vue&type=template&id=05fd096e&scoped=true&"
import script from "./ServiceTrain.vue?vue&type=script&lang=js&"
export * from "./ServiceTrain.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTrain.vue?vue&type=style&index=0&id=05fd096e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd096e",
  null
  
)

export default component.exports